import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 7a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.293 4.293a1 1 0 0 1 1.414 0L16 6.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414M15.293 23.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L16 25.414l-2.293 2.293a1 1 0 0 1-1.414-1.414zM8.209 11.5a1 1 0 0 1 1.366-.366l13.85 8a1 1 0 1 1-1 1.732l-13.85-8a1 1 0 0 1-.366-1.366"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.716 6.934a1 1 0 0 1 1.225.707l1.1 4.1a1 1 0 0 1-.707 1.225l-4.1 1.1a1 1 0 0 1-.518-1.932l3.134-.84-.841-3.135a1 1 0 0 1 .707-1.225M27.99 18.64a1 1 0 0 1-.706 1.226l-3.134.84.84 3.135a1 1 0 0 1-1.93.518l-1.1-4.1a1 1 0 0 1 .706-1.225l4.1-1.1a1 1 0 0 1 1.225.707M23.79 11.5a1 1 0 0 1-.365 1.366l-13.85 8a1 1 0 1 1-1-1.732l13.85-8a1 1 0 0 1 1.366.366"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.009 18.64a1 1 0 0 1 1.225-.706l4.1 1.1a1 1 0 0 1 .707 1.225l-1.1 4.1a1 1 0 1 1-1.932-.518l.84-3.134-3.133-.841a1 1 0 0 1-.707-1.225M24.284 6.934a1 1 0 0 1 .707 1.225l-.841 3.134 3.134.841a1 1 0 1 1-.518 1.932l-4.1-1.1a1 1 0 0 1-.707-1.225l1.1-4.1a1 1 0 0 1 1.225-.707"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconSnowflake = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSnowflake);
export default Memo;
